import { ResetPasswordCard } from "../components/reset-password-card.tsx";

function ResetPassword() {
  return <ResetPasswordCard />;
}

export default ResetPassword;
